export class Base {

    constructor(args: any) {
        if (args) {
            Object.assign(this, args);
        }
    }

}